import { useLocalStore } from 'mobx-react-lite';

import { pushNotifications } from '@gem/modules/permissions';
import { platformInfo } from '@gem/utils';

import Tasks from 'APP/Tasks';

const getShowDefault = () => {
  if (platformInfo.isFF) {
    return pushNotifications.getCurrentPermission() === 'default';
  }

  return false;
};

export default () => {
  const presenter = useLocalStore(() => ({
    isShowDialog: getShowDefault(),
    onClose() {
      presenter.isShowDialog = false;
      Tasks.pushNotifications.requestPermission();
    },
  }));

  return presenter;
};
